module.exports = __webpack_public_path__ + "img/scarlet devil mansion.d95659e8.png";